export default `
mutation BatchWriteDivisionRelations($input: [BatchDivisionRelationInput]) {
  batchWriteDivisionRelations(input: $input) {
    serviceProviderId
    divisionId
    relationalId
    updatedAt
    isDeleted
    variant
  }
}
`;